import React from 'react';
import { useQuery } from 'react-query';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { bibliotequesAPI, rayonnagesAPI } from '../../services/api';

function BibliothequeRayonnageSelector({ control, watch, setValue, disabled = false, onBibliothequeChange, onRayonnageChange }) {
  const { t } = useTranslation();
  
  // Requête pour récupérer les bibliothèques
  const { data: bibliothequesData } = useQuery(
    'bibliotheques-list',
    () => bibliotequesAPI.getAll().then(res => res.data.data),
    { staleTime: 5 * 60 * 1000, cacheTime: 10 * 60 * 1000 }
  );

  // Requête pour récupérer les rayonnages
  const { data: rayonnagesData } = useQuery(
    'rayonnages-list',
    () => rayonnagesAPI.getAll().then(res => res.data.data),
    { staleTime: 5 * 60 * 1000, cacheTime: 10 * 60 * 1000 }
  );

  return (
    <Box sx={{ maxWidth: '75vw', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
      {/* Bibliothèque */}
      <Controller
        name="bibliotheque_id"
        control={control}
        render={({ field }) => (
          <FormControl fullWidth>
            <InputLabel>{t('booksPage.library')}</InputLabel>
            <Select 
              {...field} 
              label={t('booksPage.library')}
              disabled={disabled}
              sx={{
                borderRadius: 2,
              }}
              onChange={(e) => {
                field.onChange(e);
                // Réinitialiser le rayonnage quand la bibliothèque change
                setValue('rayonnage_id', '');
                // Appeler le callback si fourni
                if (onBibliothequeChange) {
                  onBibliothequeChange(e.target.value);
                }
              }}
            >
              <MenuItem value="">
                <em>{t('booksPage.noLibraryOption')}</em>
              </MenuItem>
              {bibliothequesData?.map((bibliotheque) => (
                <MenuItem key={bibliotheque.id} value={bibliotheque.id}>
                  {bibliotheque.nom}
                  {bibliotheque.piece && ` (${bibliotheque.piece})`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      />
      
      {/* Rayonnage */}
      <Controller
        name="rayonnage_id"
        control={control}
        render={({ field }) => {
          const selectedBibliothequeId = watch('bibliotheque_id');
          const filteredRayonnages = rayonnagesData?.filter(rayonnage => 
            rayonnage.bibliotheque_id === parseInt(selectedBibliothequeId)
          ) || [];
          
          return (
            <FormControl fullWidth>
              <InputLabel>{t('booksPage.shelf')}</InputLabel>
              <Select 
                {...field} 
                label={t('booksPage.shelf')}
                disabled={disabled || !selectedBibliothequeId}
                sx={{
                  borderRadius: 2,
                }}
                onChange={(e) => {
                  field.onChange(e);
                  // Appeler le callback si fourni
                  if (onRayonnageChange) {
                    onRayonnageChange(e.target.value);
                  }
                }}
              >
                <MenuItem value="">
                  <em>{t('booksPage.noShelf')}</em>
                </MenuItem>
                {filteredRayonnages.map((rayonnage) => (
                  <MenuItem key={rayonnage.id} value={rayonnage.id}>
                    {rayonnage.nom}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        }}
      />
    </Box>
  );
}

export default BibliothequeRayonnageSelector;
